import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/hr/leavemanagement/accruals/:id',
    name: 'leave-accrual-view',
    component: () => import('../components/LeaveAccrualView.vue'),
    props: true
  }
]

export default routes
